import React from "react";

const PhoneNumberActionConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 10000000000 }}>
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-5">
          <p className="text-sm text-gray-700 mb-4">
            This should not be done during business hours. Do you want to continue?
          </p>
          <div className="flex justify-end gap-3">
            <button
              className="px-4 py-2 border border-gray-300 text-sm rounded hover:bg-gray-50"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-sm text-white rounded hover:opacity-90"
              style={{ backgroundColor: "rgb(79, 70, 229)" }}
              onClick={onConfirm}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberActionConfirmModal;
